import Vue from 'vue';
import App from '../App';
import router from '../router';
import store from '../store';

const MAIN_APPLICATION_OPTIONS = {
  router,
  store,
  components: { App },
  template: '<App/>',
};

export default {
  getNewVueApp() {
    const MainApplication = Vue.extend(MAIN_APPLICATION_OPTIONS);
    return new MainApplication().$mount();
  },
};




// WEBPACK FOOTER //
// ./src/factories/vue.component.factory.js